export default function(x) {
  return x === null ? NaN : +x;
}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-array/src/number.js
// module id = 23
// module chunks = 0